import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useParams } from "react-router-dom";

import logo from "../assets/images.png";
import qr from "../assets/QR.png";
import Api from "../api/Api";
import formatarValor from "../formatarValor";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const toBase64 = (url) =>
  fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );

const FacturaTicket = () => {
  const { id } = useParams();
  const [ultimosPedidos, setUltimosPedidos] = useState([]);
  const [empresa, setEmpresa] = useState(null);
  const [banco1, setbanco1] = useState("");
  const [banco2, setbanco2] = useState("");
  const [nDoc, setnDoc] = useState(null);
  const [vExtenso, setvExtenso] = useState(null);
  const [nome, setNome] = useState("");
  const [nif, setNif] = useState("");
  const [loading, setLoading] = useState(true);
  const pdfRef = useRef();

  const BASE_IMAGE_URL = "https://qrorder.milvendas.ao/public/img/";
  const IMG_ALTERNATIVA = "https://qrorder.milvendas.ao/public/img/default.png";

  const totalGeral = ultimosPedidos.reduce(
    (sum, pedido) => sum + parseFloat(pedido.total || 0),
    0
  );

  useEffect(() => {
    carregar();
  }, []);

  const carregar = async () => {
    try {
      setLoading(true);
      const dados = { id };

      const [pedidosData, empresaData, empresaConta, dadosDocumento] =
        await Promise.all([
          Api.ListPedidoFactura(dados),
          Api.ListEmpresa(),
          Api.ListConta(),
          Api.LisDocumento(dados),
        ]);

      if (Array.isArray(pedidosData)) {
        const formatado = pedidosData.map((item) => ({
          produto: item.produto,
          qtd: item.quantidade,
          total: item.total,
          valor: item.preco,
        }));
        setUltimosPedidos(formatado);
      }

      if (empresaData) {
        const emp = Array.isArray(empresaData) ? empresaData[0] : empresaData;
        if (emp) {
          setEmpresa({
            ...emp,
            img: emp.img
              ? emp.img.startsWith("http")
                ? emp.img
                : `${BASE_IMAGE_URL}${emp.img}`
              : IMG_ALTERNATIVA,
          });
        }
      }

      if (Array.isArray(empresaConta)) {
        if (empresaConta.length > 0)
          setbanco1(`${empresaConta[0].iban} | ${empresaConta[0].banco}`);
        if (empresaConta.length > 1)
          setbanco2(`${empresaConta[1].iban} | ${empresaConta[1].banco}`);
      }

      let doc = dadosDocumento
        ? Array.isArray(dadosDocumento)
          ? dadosDocumento[0]
          : dadosDocumento
        : null;

      setnDoc(doc);

      if (doc?.total) {
        const valorExt = await Api.GetExtenso({ id });
        setvExtenso(valorExt.extenso);

        const cliente = await Api.ListNome({ id });
        setNome(cliente.nome);
        setNif(cliente.nif);
      }
    } finally {
      setLoading(false);
    }
  };



const gerarPDF = async () => {
  let logoBase64;
  try {
    logoBase64 = await toBase64(empresa?.img || logo);
  } catch {
    logoBase64 = await toBase64(logo);
  }
  const qrBase64 = await toBase64(qr);

  const doc = new jsPDF({
    unit: "in",
    format: [2.90773, 12], // largura fixa do ticket
  });

  let y = 0.20;

  // LOGO
  try {
    doc.addImage(logoBase64, "PNG", 0.60, y, 1.7, 0.7);
  } catch {}
  y += 0.85;

  // ============================
  // DADOS DA EMPRESA AJUSTADOS
  // ============================
  doc.setFontSize(8);

if (empresa) {
  const maxWidth = 2.7;

  doc.text(empresa.nome || "", 0.15, y, { maxWidth });
  y += 0.18;

  if (empresa.endereco) {
    doc.text(empresa.endereco, 0.15, y, { maxWidth });
    y += 0.18;
  }

  if (empresa.telefone) {
    doc.text(`Telefone: ${empresa.telefone}`, 0.15, y, { maxWidth });
    y += 0.18;
  }

  if (empresa.email) {
    doc.text(`E-mail: ${empresa.email}`, 0.15, y, { maxWidth });
    y += 0.18;
  }
}

  y += 0.08;

  y += 0.12;

  // DOCUMENTO
  doc.setFontSize(8);
  doc.text(`Factura: ${nDoc?.numero}`, 0.15, y);
  y += 0.16;

  if (nDoc?.dataemissao) {
    doc.text(`Data: ${nDoc.dataemissao}`, 0.15, y);
    y += 0.16;
  }

  // CLIENTE
  doc.text(`Cliente: ${nome}`, 0.15, y);
  y += 0.16;
  doc.text(`NIF: ${nif}`, 0.15, y);
  y += 0.16;


  y += 0.10;

  // ============================
  // TABELA - AJUSTE ESQUERDA
  // ============================
  const items = ultimosPedidos.map((p) => [
    p.produto,
    p.qtd.toString(),
    formatarValor(p.total),
  ]);

  doc.autoTable({
    head: [["DESCRIÇÃO", "QTD", "TOTAL"]],
    body: items,
    startY: y,
    theme: "plain",
    styles: {
      fontSize: 7,
      cellPadding: 0.03,
      valign: "middle",
    },
    headStyles: {
      fontSize: 7,
    },
    columnStyles: {
      0: { cellWidth: 1.55, halign: "left" },   // descrição mais à esquerda
      1: { cellWidth: 0.35, halign: "center" }, // qtd pequena
      2: { cellWidth: 0.55, halign: "right" },  // total
    },
    margin: { left: 0.15 },  // *** deixa toda a tabela colada à esquerda ***
  });

  y = doc.lastAutoTable.finalY + 0.18;

  // TOTAL
  doc.setFontSize(9);
  doc.text(`TOTAL: ${formatarValor(totalGeral)}`, 0.15, y);
  y += 0.25;

  doc.setFontSize(7);
  doc.text(vExtenso || "", 0.15, y, { maxWidth: 2.6 });
  y += 0.35;


  y += 0.15;

  // BANCOS
  doc.setFontSize(7);
  if (banco1) {
    doc.text(banco1, 0.15, y);
    y += 0.15;
  }
  if (banco2) {
    doc.text(banco2, 0.15, y);
    y += 0.15;
  }

  y += 0.15;

  // QR CODE
  
 

  doc.setFontSize(6);
  doc.text("Processado por computador - QR Order - MIL VENDAS", 0.30, y);

  // DOWNLOAD
const blob = doc.output("blob");
const url = URL.createObjectURL(blob);
if (pdfRef.current) pdfRef.current.src = url;


  if (pdfRef.current) pdfRef.current.src = url;
};


 






  useEffect(() => {
    if (!loading && ultimosPedidos.length > 0) {
      gerarPDF();
    }
  }, [loading, ultimosPedidos]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
        <p>Gerando documento…</p>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe ref={pdfRef} width="100%" height="100%" style={{ border: "none" }} />
    </div>
  );
};

export default FacturaTicket;
